export const UPDATE_PROTYPE = "UPDATE_PROTYPE";
export const UPDATE_ENV = "UPDATE_ENV";
export const UPDATE_VEHICLEINFO = "UPDATE_VEHICLEINFO";
export const UPDATE_USER_INFO = "UPDATE_USER_INFO";
